import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import VersionInfo from 'src/assets/version.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  /**
   * 
   * @param authService 
   * @param router 
   */
  constructor(private authService: AuthService, private router: Router) { }

  /**
   * 
   */
  async logout() {
    try {
      await this.authService.signOut().toPromise();
      this.router.navigate(['/']);
    } catch (err) {
      console.error(err);
    }
  }

  vm$: Observable<IViewModel>;

  /**
   * 
   */
  ngOnInit() {

    this.vm$ = this.authService.watchState$().pipe(
      map(authState => {
        const ret: IViewModel = {
          isLoggedIn: authState.isLoggedIn,
          userName: authState.userInfo?.title,
          navLinks: authState.navLinks ?? [],
    
          displayTitle: environment.title,
          displayVersion: `${VersionInfo.major}.${VersionInfo.minor}.${VersionInfo.build}`,
          displayEnv: environment.env
        };   
        return ret;
      })
    );
  }
}

/**
 * 
 */
interface IViewModel {
  displayTitle: string;
  displayVersion: string;
  displayEnv?: string;
  
  isLoggedIn: boolean;

  userName?: string;
  navLinks: any[];
}

